import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseWidget } from '../base.widget';
import * as fromRoot from '../../store';
import { ToggleWidget } from '../../store/actions';

@Component({
  selector: 'worker-vetting-component',
  templateUrl: './worker.vetting.component.html',
})
export class WorkerVettingComponent implements OnInit {
  public isLoading: boolean;
  public data: any[] = [];
  public widgetData: any;
  public showChart: boolean;
  public chartSize = [440, 250];
  private subscriptions = [];
  private dragMode: boolean;
  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit() {
    this.subscriptions.push(
      this.store.select(fromRoot.getWorkerInfo).subscribe((info) => {
        let statusMap = {
          Candidates: info.total_count,
          Vetted: 0,
          Working: 3,
        };

        this.data = Object.keys(statusMap).map((key) => {
          let value = statusMap[key];
          return { name: key, value: value };
        });
      })
    );

    this.subscriptions.push(
      this.store.select(fromRoot.getDragMode).subscribe((dragMode) => (this.dragMode = dragMode))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  closeWidget() {
    this.store.dispatch(new ToggleWidget(this.widgetData, true));
  }

  toggleChart() {
    this.showChart = !this.showChart;
  }
}
